(function () {
    'use strict';

    angular
        .module('app.application.role')
        .controller('RoleDashboardController', RoleDashboardController);

    /* @ngInject */
    function RoleDashboardController(
        $q,
        logger,
        $uibModal,
        moment,
        $stateParams,
        roleService, dialogService) {

        //Private Variables
        var vm = this;
        var roleModalOptions = roleService.getModalOptions();

        //Public Variables
        vm.roles = [];
        vm.isFilterCollapsed = true;
        vm.title = '';
        vm.ApplicationID = $stateParams.ApplicationID;
        vm.loadingMessage = 'Loading ... ';

        //Public Methods
        vm.getRolesByApplication = getRolesByApplication;
        vm.addRole = addRole;
        vm.editRole = editRole;
        vm.deleteRole = deleteRole;

        //smart table
        vm.tableConfig = configureTableActions();

        // DI / IOC / unit testing / mocking
        vm.roleService = roleService;

        //Activate Controller
        activate();

        function activate() {
            logger.info('Activated role Dashboard View');
        }

        function getRolesByApplication(tableState) {
            return roleService.getRolesByApplication($stateParams.ApplicationID, tableState)
            .then(function (result) {
                if (result.length > 0) {
                    vm.title = result[0].Application.ApplicationName;
                }

                return result;
            });
        }

        function addRole() {
            roleModalOptions.controller = 'RoleAddController';
            var modalInstance = $uibModal.open(angular.extend({
                resolve: {
                    applictionID: function () {
                        return parseInt($stateParams.ApplicationID);
                    }
                }
            }, roleModalOptions));

            modalInstance.result.then(function (newrole) {
                vm.isLoading = false;
                vm.roles.unshift(newrole);
            }, function () {
                logger.info('Modal dismissed at: ' + new Date());
            });
        }

        function editRole(role) {
            roleModalOptions.controller = 'RoleEditController';
            var modalInstance = $uibModal.open(angular.extend({
                resolve: {
                    role: function () {
                        return role;
                    }
                }
            }, roleModalOptions));

            modalInstance.result.then(function (updatedrole) {
                role = updatedrole;
            }, function () {
                logger.info('Modal dismissed at: ' + moment().format());
            });
        }

        function deleteRole(role) {
            return dialogService.confirm()
               .then(function () {
                   return roleService.deleteRole(role);
               }).then(function (result) {
                   if (result.status === 200) {
                       var index = vm.roles.indexOf(role);
                       vm.roles.splice(index, 1);
                       logger.info('Role Deleted', result);
                   } else {
                       logger.error('Error Deleting Role', result);
                   }
               });
        }

        function configureTableActions() {
            var tableConfig = roleService.getTableConfig();
            tableConfig.actions = [
            {
                name: '"Edit"',
                action: editRole,
                icon: '"fa-edit"',
                permission: 'SSO:SysAdmin'

            }];
            return tableConfig;
        }
    }
})();
